

function init() {

  const options = { rootMargin: '-40% 0px -40%', threshold: 0 }
  const callback = ( entries, observer ) => {
    for( const entry of entries ) {
      if( entry.isIntersecting ) {
        const element = entry.target
        const block = element.closest( '.block.product' )
        const title = element.querySelector( 'h2[id]' )
        if( !title ) return
        const nav = block.querySelector( 'a[data-nav="'+title.id+'"]' )
        if( !nav ) return
        const navs = block.querySelectorAll( 'a[data-nav]' )
        for( const el of navs ) el.classList.remove( 'active' )
        nav.classList.add( 'active' )
      }
    }
  }

  const observer = new IntersectionObserver( callback, options )

  const blocks = document.querySelectorAll( '.block.product' )
  if( blocks.length === 0 ) return
  for( const block of blocks ) {
    const elements = block.querySelectorAll( 'section' )
    if( elements.length === 0 ) continue
    for( const element of elements ) observer.observe( element )
  }

}

function destroy() {
}

export default { init, destroy }
